import React, {Component} from 'react';
import {observer,inject} from "mobx-react";
import Portal from "./Helpers/Portal";
import {StoreContext} from "../stores/contexts";

class ContextMenu extends Component {
  static contextType = StoreContext;

  componentDidMount() {
    document.addEventListener("click", this.handleClick);
  }
  handleClick=(e)=>{
    if(this.context.contextStore.type) {
      this.context.contextStore.hide();
    }
  }
  render() {
    if(this.context.contextStore.type === 'header') {

      return (
        <Portal>
          <div className="pa z4 bg-w1 shadow" style={{left:this.context.contextStore.mouse.x, top:this.context.contextStore.mouse.y }}>
            <div onClick={()=>{ this.context.configStore.removeFieldFromLayout(this.context.contextStore.data.code); }} className="vpadd5 hpadd10 const1 pointer bg-const1-hover w1-hover">
              Убрать колонку
            </div>
          </div>
        </Portal>
      )
    }
    return null;
  }
}

// export default inject("contextStore","configStore")(observer(ContextMenu));
export default observer(ContextMenu);